import 'projects/sharedComponents/src/pet/shareModal/shareModal.scss';

import { Box, Link, Typography } from '@mui/material';
import { Heap, HeapAction } from 'clientServerShared/types/eventTracking';
import { UrlPathPrefix, buildMyEvLegacyLink } from 'projects/sharedComponents/src/services/links/linkBuilder';

import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import GetAppIcon from '@mui/icons-material/GetApp';
import { HelixDialog } from '@projectaussie/component-library';
import LinkIcon from '@mui/icons-material/Link';
import { ShareButtonFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';
import { copyLinkButtonOnClickHandler } from 'projects/sharedComponents/src/services/eventHandlers/copyLinkButtons';
import { useState } from 'react';

type ShareModalProps = {
  open: boolean;
  onClose: () => void;
  shareOptions: ShareButtonFragment;
} & Heap;

export const ShareModal: React.FC<ShareModalProps> = (props) => {
  const downloadUrl = props.shareOptions.downloadUrl
    ? buildMyEvLegacyLink(props.shareOptions.downloadUrl as UrlPathPrefix)
    : undefined;
  const [copyLinkText, setCopyLinkText] = useState('COPY LINK');

  const copyLink = async (event: React.MouseEvent<HTMLAnchorElement>): Promise<void> => {
    event.preventDefault();
    await copyLinkButtonOnClickHandler(event);
    setCopyLinkText('LINK COPIED');
    setTimeout(() => {
      setCopyLinkText('COPY LINK');
    }, 3000);
  };

  const heapCategory = props.heapMetadata?.heapCategory;
  return (
    <HelixDialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="xs"
      className="shareModal-modal"
      aria-labelledby="share-results-header"
    >
      <Box ml={3} mt={-2}>
        <Typography variant="h6" component="h2" id="share-results-header">
          <strong>Share Results</strong>
        </Typography>
        <div className="shareModal-shareOptions">
          <Box mt={1.5}>
            <Link
              href={props.shareOptions.emailMailTo}
              data-heap-action={HeapAction.SHARE_RESULTS_EMAIL}
              data-heap-category={heapCategory}
            >
              <EmailIcon />
              EMAIL
            </Link>
          </Box>
          <Box mt={1.5}>
            <Link
              href={props.shareOptions.facebookUrl}
              target="_blank"
              rel="noopener"
              data-heap-action={HeapAction.SHARE_RESULTS_FACEBOOK}
              data-heap-category={heapCategory}
            >
              <FacebookIcon />
              FACEBOOK
            </Link>
          </Box>
          <Box mt={1.5}>
            <Link
              href={downloadUrl}
              download={props.shareOptions.shareItemId}
              data-heap-action={HeapAction.SHARE_RESULTS_DOWNLOAD}
              data-heap-category={heapCategory}
            >
              <GetAppIcon />
              DOWNLOAD
            </Link>
          </Box>
          <Box mt={1.5}>
            <Link
              href={props.shareOptions.copyLinkUrl}
              onClick={copyLink}
              data-heap-action={HeapAction.SHARE_RESULTS_COPY_LINK}
              data-heap-category={heapCategory}
            >
              <LinkIcon />
              {copyLinkText}
            </Link>
          </Box>
        </div>
      </Box>
    </HelixDialog>
  );
};
